import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled from 'styled-components';

import { rowHeight } from './constants';

export const CategoryContainer = styled.div`
  height: ${rowHeight}px;
  padding: ${({ theme }) => `0 ${theme.spacing(1.5)} 0 ${theme.spacing(2)}`};

  /* Add spacing above all categories except the first */
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing(4)};
  }
`;

export const CategoryCreateButtonContainer = styled.span`
  opacity: 0;
  transition: opacity 200ms;

  line-height: 62.5%;
`;

export const CategoryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ theme }) => `${theme.spacing(2)} 0 ${theme.spacing(1.75)} 0`};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.default};

  &:hover {
    ${CategoryCreateButtonContainer} {
      opacity: 1;
    }
  }
`;

export const ChevronContainer = styled.span`
  opacity: 0;
  transform: rotate(180deg);
  transition: opacity 200ms;

  line-height: 62.5%;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const CategoryLinkContainer = styled(QueryNavLink)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing(0.25)} 0`};

  min-width: 0;

  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    ${ChevronContainer} {
      opacity: 1;
    }
  }
`;

export const CategoryTitle = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const CategoryButtonsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const GoalListItem = styled.div<{
  $isDragging: boolean;
  $level: number;
}>`
  position: relative;
  padding-left: ${({ theme, $level }) =>
    `calc(${$level} * ${theme.spacing(2)})`};
  height: ${rowHeight}px;

  opacity: ${({ $isDragging }) => ($isDragging ? 0.7 : 1)};
  background: ${({ theme }) => theme.palette.background.default};
`;

export const GoalListItemInner = styled.div`
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(2)};
  transition: background 200ms;
  transform: translate(0, 0);

  &:hover {
    background: ${({ theme }) => theme.palette.grey[50]};
  }
`;
